module.exports = __webpack_public_path__ + "img/accessory_pants_08.bb89e975.svg";